import React, { useEffect, useState } from "react";
import { Button, Empty, Table, Typography } from "antd";
import { BellOutlined, MailOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import SendNotification from "../Modals/SendNotification";
import SendEmail from "../Modals/SendEmail";
import UserServices from "../../services/UserServices";
import { translate } from "../../locale";
import { TableHelper } from "../../helpers/TableHelper";

const { Text } = Typography;

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const BehindUsers = ({ selectedData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [selecteUser, setSelecteUser] = useState(null);
  const [showEmail, setShowEmail] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const navigate = useNavigate();

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-2">
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendNotification(record.username);
            }}
          >
            <BellOutlined className="text-black" />
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              handleSendEmail(record.username);
            }}
          >
            <MailOutlined className="text-black" />
          </Button>
        </div>
      ),
      fixed: "left",
    },
    {
      title: "Apellido",
      dataIndex: "surname",
      key: "surname",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.surname}
        </a>
      ),
      sorter: { multiple: 1 },
      fixed: "left",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      render: (_, record) => (
        <a
          onClick={() => navigate(`/admin/buscar-paciente/${record.username}`)}
          className="text-black hover:text-custom_primary"
        >
          {record.name}
        </a>
      ),
      sorter: { multiple: 2 },
    },
    {
      title: "Registros atrasados",
      dataIndex: "inactive_days",
      key: "inactive_days",
      // sorter: { multiple: 3 },
      render: (_, record) => {
        return (
          <>
            {record.last_control > 0 && (
              <div>
                {translate("Automedición")}{" "}
                <Text className="text-custom_red">{record.last_control}</Text>{" "}
                {translate("días")}
              </div>
            )}
            {record.last_feeding > 0 && (
              <div>
                {translate("Alimentación")}{" "}
                <Text className="text-custom_red">{record.last_feeding}</Text>{" "}
                {translate("días")}
              </div>
            )}
            {record.last_mt > 0 && (
              <div>
                {translate("Medicamento")}{" "}
                <Text className="text-custom_red">{record.last_mt} </Text>
                {translate("días")}
              </div>
            )}
            {record.last_survey > 0 && (
              <div>
                {translate("Autoevaluación")}{" "}
                <Text className="text-custom_red">{record.last_survey}</Text>{" "}
                {translate("días")}
              </div>
            )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    if (selectedData !== null) {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      loadData(data);
    }
  }, [selectedData, JSON.stringify(tableParams)]);

  const loadData = async (data) => {
    setLoading(true);
    try {
      const response = await UserServices.getBehindUser(
        selectedData.period,
        selectedData.suscription,
        null,
        data
      );
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.inactives);
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSendNotification = (username) => {
    setSelecteUser(username);
    setShowNotification(true);
  };

  const handleSendEmail = (username) => {
    setSelecteUser(username);
    setShowEmail(true);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <>
      <Table
        rowKey={(i) => i.username}
        dataSource={data}
        columns={columns}
        loading={
          loading
            ? { indicator: antIcon, className: "text-custom_blue" }
            : false
        }
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      <SendNotification
        patient={selecteUser}
        visible={showNotification}
        onCancel={() => setShowNotification(false)}
        onComplete={() => setShowNotification(false)}
      />
      <SendEmail
        patient={selecteUser}
        visible={showEmail}
        onCancel={() => setShowEmail(false)}
        onComplete={() => setShowEmail(false)}
      />
    </>
  );
};

export default BehindUsers;
